module.exports = __webpack_public_path__ + "044925937542419b27662f0762ce978b.pdf";